export enum NotificationSource {
    Desktop = 1,
    Mobile = 2,
}
